import { render, staticRenderFns } from "./Recepcao.vue?vue&type=template&id=71d016ab&"
import script from "./Recepcao.vue?vue&type=script&lang=js&"
export * from "./Recepcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports